import { render, staticRenderFns } from "./SuppliesConfirmationModal.vue?vue&type=template&id=6d13b9c4&scoped=true"
import script from "./SuppliesConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SuppliesConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./SuppliesConfirmationModal.vue?vue&type=style&index=0&id=6d13b9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d13b9c4",
  null
  
)

export default component.exports